import React, { useRef } from "react";
import { TAG_DEFS } from "./demoData";

export default function DocumentPreview({ wf, step, started, completed, file, approvals = {}, onToast }) {
  const bodyRef = useRef(null);
  const s = wf.steps[step];

  const copy = async () => {
    if (bodyRef.current) {
      await navigator.clipboard.writeText(bodyRef.current.innerText);
      onToast("📋 Copied to clipboard");
    }
  };

  const exportDoc = () => {
    const line = "────────────────────────────────────────";
    const rows = s.fields.map((f) => `${f.k}: ${f.v}`).join("\n");
    let text = `${line}\nLabComplyx — ${wf.name}\nDocument: ${wf.docId}\nStep: ${s.label}\nRegulation: ${s.reg}\nGenerated: ${new Date().toISOString()}\n${line}\n${s.section}\n${rows}\n${line}\n`;
    if (file) text += `UPLOADED FILE\nFile: ${file.name}\nSize: ${file.sizeKB} KB\n${line}\n`;
    const blob = new Blob([text], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${wf.docId}-${s.label.replace(/\s+/g, "")}.txt`;
    a.click();
    URL.revokeObjectURL(url);
    onToast("📄 Document exported");
  };

  return (
    <>
      <div className="lcx-box-head">
        <span className="t">📄 Document Preview</span>
        <div className="lcx-doc-actions">
          <button type="button" className="lcx-doc-btn" onClick={copy}>Copy</button>
          <button type="button" className="lcx-doc-btn" onClick={exportDoc}>Export</button>
        </div>
      </div>

      {started && (
        <div className="lcx-doc-tags">
          {s.tags.map((t) => {
            const def = TAG_DEFS[t];
            return <span key={t} className={`lcx-dtag ${def.color}`}>{def.label}</span>;
          })}
        </div>
      )}

      <div className="lcx-doc-body" ref={bodyRef}>
        {started ? (
          <>
            {file && <div style={{ marginBottom: "0.5rem" }} className="lcx-doc-row"><span className="hl">Processing: {file.name}</span></div>}
            <div className="lcx-doc-sec">▸ {s.section}</div>
            {s.fields.map((f, i) => (
              <div key={i} className="lcx-doc-row">
                <span className="k">{f.k}: </span>
                <span className={f.c || ""}>{f.v}</span>
              </div>
            ))}
            {file && (
              <>
                <div className="lcx-doc-sec">▸ Uploaded File</div>
                <div className="lcx-doc-row"><span className="k">Uploaded File: </span><span className="hl">{file.name}</span></div>
                <div className="lcx-doc-row"><span className="k">File Size: </span><span>{file.sizeKB} KB</span></div>
                <div className="lcx-doc-row">
                  <span className="k">AI Processing: </span>
                  <span className="hl">Content extracted and mapped to workflow<span className="lcx-cursor" /></span>
                </div>
              </>
            )}
          </>
        ) : (
          <span style={{ opacity: 0.6 }}>Select a workflow and press Run Demo to generate audit-ready evidence…</span>
        )}
      </div>

      {completed && (
        <div className="lcx-banner">
          <div className="b-title">🎉 {wf.name} Complete</div>
          <div className="b-score">{wf.completionScore}</div>
          <p className="b-msg">{wf.completionMsg}</p>
          {Object.keys(approvals).length > 0 && (
            <div style={{ marginTop: "0.65rem", fontSize: "0.78rem", textAlign: "left" }}>
              <div style={{ fontWeight: 700, marginBottom: "0.3rem" }}>✍️ Human Approvals Applied</div>
              {Object.entries(approvals).map(([idx, a]) => (
                <div key={idx} style={{ opacity: 0.85 }}>
                  ✅ {wf.steps[idx].label} — approved by {a.name} · {new Date(a.time).toLocaleString()} · {wf.steps[idx].reg}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}